module.exports = __webpack_public_path__ + "static/media/iep-ui-design02-thumb.ae47dbf9.png";